<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card v-if="dialog">

      <v-toolbar flat dark color="primary">
        <v-btn icon dark @click="close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Settings</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text :disabled="list !== 'tune'" @click="createImage()">Guardar</v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card-text class="pl-0">
        <v-row no-gutters>

          <v-col cols="5" md="4" lg="3">
            <v-row no-gutters>

              <v-col cols="2" style="height: 91vh; border-right: 1px solid #E0E0E0;">
                <v-list-item-group v-model="list" color="primary">
                  <v-list class="pt-0">

                    <v-list-item class="px-2" :value="'crop'">
                      <v-list-item-content>
                        <v-icon>mdi-resize</v-icon>
                      </v-list-item-content>
                    </v-list-item>
                  
                    <v-divider/>

                    <v-list-item class="px-2" :disabled="list == 'crop'" :value="'draw'">
                      <v-list-item-content>
                        <v-icon>mdi-drawing</v-icon>
                      </v-list-item-content>
                    </v-list-item>
                    
                    <v-divider/>

                    <v-list-item class="px-2" disabled :value="'tune'">
                      <v-list-item-content>
                        <v-icon>mdi-tune</v-icon>
                      </v-list-item-content>
                    </v-list-item>
                    
                    <v-divider/>
                    
                  </v-list>
                </v-list-item-group>
              </v-col>

              <v-col cols="10" style="height: 91vh; border-right: 1px solid #E0E0E0;">
                <v-card-text>
                  <v-container>
                    <v-window v-model="list">
                      
                      <v-window-item :value="'crop'">
                        <v-row no-gutters align="center" v-show="list === 'crop'">
                          <!-- <v-col cols="6">
                            <v-btn color="deep-orange" class="white--text" @click="cropImage()">crop</v-btn>
                          </v-col> -->
                          <v-col cols="12" class="text-right">
                            <v-btn depressed color="primary" class="white--text" @click="confirmCrop()">Confirmar</v-btn>
                          </v-col>
                          <v-col cols="12">
                            <v-subheader class="pl-0">Previsualización</v-subheader>
                            <div class="preview px-4" />
                          </v-col>
                          <v-col cols="12">
                            <v-switch label="Cuadrícula" v-model="guides"></v-switch>
                          </v-col>
                          <!-- <v-col cols="12" class="py-4">
                            <v-subheader class="pl-0">Resultado</v-subheader>
                            <v-expand-x-transition>
                              <v-img :src="imageToCrop" contain aspect-ratio="1" width="100%" v-if="imageToCrop"></v-img>
                            </v-expand-x-transition>
                          </v-col> -->
                        </v-row>
                      </v-window-item>
                      
                      <v-window-item :value="'draw'">
                        <v-row no-gutters v-if="list === 'draw'">
                          <v-col cols="6">
                          </v-col>
                          <v-col cols="6">
                            <v-btn depressed color="primary" class="white--text" @click="confirmDraw()">Confirmar</v-btn>
                          </v-col>
                          <v-col cols="12" class="py-2">
                            <v-btn depressed color="primary" class="white--text" @click="addRect()">Añadir</v-btn>
                          </v-col>
                          <v-col cols="12" class="py-2">
                            <v-btn depressed color="primary" class="white--text" :disabled="!selectedShapeName" @click="removeRect()">Borrar</v-btn>
                          </v-col>
                        </v-row>
                      </v-window-item>

                      <v-window-item :value="'tune'">
                        <v-row no-gutters v-if="list === 'tune'">

                          <v-col cols="6" class="text-left">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-btn fab small depressed color="deep-orange" class="white--text mr-2" v-on="on" @click="reset()">
                                  <v-icon>mdi-reload</v-icon>
                                </v-btn>
                              </template>
                              <span>Reiniciar</span>
                            </v-tooltip>
                          </v-col>

                          <v-col cols="6" class="text-right">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-btn fab small depressed color="primary" class="white--text" v-on="on" @click="createImage(true)">
                                  <v-icon>mdi-download</v-icon>
                                </v-btn>
                              </template>
                              <span>Descargar</span>
                            </v-tooltip>
                          </v-col>

                          <v-col cols="12">
                            <v-subheader class="pl-0">Brillo</v-subheader>
                            <v-slider
                              v-model="tune.brightness"
                              color="primary"
                              thumb-label
                              step="0.01"
                              min="0"
                              max="5"
                            ></v-slider>
                          </v-col>

                          <v-col cols="12">
                            <v-subheader class="pl-0">Contraste</v-subheader>
                            <v-slider
                              v-model="tune.contrast"
                              color="primary"
                              thumb-label
                              step="0.01"
                              min="0"
                              max="10"
                            ></v-slider>
                          </v-col>

                          <v-col cols="12">
                            <v-subheader class="pl-0">Saturación</v-subheader>
                            <v-slider
                              v-model="tune.saturate"
                              color="primary"
                              thumb-label
                              step="0.01"
                              min="0"
                              max="2"
                            ></v-slider>
                          </v-col>

                        </v-row>
                      </v-window-item>
                      
                    </v-window>
                  </v-container>
                </v-card-text>
              </v-col>

            </v-row>
          </v-col>

          <v-col cols="7" md="8" lg="9">
            <v-container style="overflow: hidden !important; height: 88vh">
              <v-row no-gutters align="center" justify="center" class="fill-height pa-0" style="overflow: hidden !important;">
                <v-window v-model="list" touchless>

                  <v-window-item :value="'crop'">
                    <vue-cropper
                      v-if="list === 'crop' && image"
                      ref="cropper"
                      alt="Source Image"
                      :src="image"
                      movable
                      zoomable
                      responsive
                      dragMode="move"
                      :guides="guides"
                      :center="false"
                      :autoCropArea="1"
                      :cropBoxMovable="false"
                      :cropBoxResizable="false"
                      :toggleDragModeOnDblclick="false"
                      preview=".preview"
                      :key="guides"
                    ></vue-cropper>
                  </v-window-item>
                  
                  <v-window-item :value="'draw'">
                    <v-stage
                      v-if="list === 'draw'"
                      ref="stage"
                      :config="configKonva"
                      @mousedown="handleStageMouseDown"
                      @touchstart="handleStageMouseDown"
                    >
                      <v-layer ref="layer">
                        <v-image 
                          ref="image_draw"
                          :config="{
                            image: cropImg,
                            filters: filters,
                            width: 800,
                            height: 800
                          }"
                          :key="component"
                        />
                        <!-- <v-circle :config="configCircle"></v-circle> -->
                        <v-rect
                          v-for="item in rectangles"
                          :key="item.id"
                          :config="item"
                          @transformend="handleTransformEnd"
                        />
                        <v-transformer ref="transformer" />
                      </v-layer>
                    </v-stage>
                  </v-window-item>

                  <v-window-item :value="'tune'">
                    <img
                      v-if="list === 'tune'"
                      id="image_tune"
                      crossorigin="anonymous"
                      width="100%"
                      :src="drawImg"
                      :style="filters"
                      style="background-color: #8C8C8C"
                    />
                  </v-window-item>

                </v-window>
              </v-row>
            </v-container>
          </v-col>

        </v-row>
      </v-card-text>

    </v-card>
  </v-dialog>
</template>

<style>
.preview {
  width: 100%;
  height: calc(372px * 9 / 16);
  margin: auto;
  overflow: hidden;
  background-color: #8C8C8C;
}
</style>

<script>
export default {
  props: {
    value: Boolean,
    item: { type: Object, default: () => {} }
  },
  data: () => ({
    component: 0,
    dialog: false,
    image: null,
    cropImg: null,
    drawImg: null,
    height: null,
    width: null,
    list: 'crop',
    tune: {
      brightness: 1,
      contrast: 1,
      saturate: 1
    },
    guides: false,
    configKonva: {
      width: 800,
      height: 800
    },
    configCircle: {
      x: 100,
      y: 100,
      radius: 70,
      stroke: "red",
      strokeWidth: 4
    },
    configRect: {
      rotation: 0,
      x: 10,
      y: 10,
      width: 100,
      height: 100,
      scaleX: 1,
      scaleY: 1,
      stroke: 'red',
      fill: '',
      name: 'rect',
      draggable: true,
    },
    rectangles: [],
    selectedShapeName: '',
    index: 0,
  }),
  watch: {
    value (val) {
      this.dialog = val
      if (val) this.init()
    }
  },
  computed: {
    loading: {
      get () {
        return this.$store.state.loading
      },
      set (val) {
        this.$store.commit('loading', val)
      }
    },
    filters () {
      const toDash = (str) => str.replace( /([a-z])([A-Z])/g, '$1-$2' ).toLowerCase()
      return { 
        filter: Object.entries(this.tune).filter(item => typeof(item[1]) !== 'object').map(item => `${toDash(item[0])}(${item[1]})`).join(' ') 
      }
    }
  },
  methods: {
    reset () {
      this.rectangles = []
      this.tune = {
        brightness: 1,
        contrast: 1,
        saturate: 1
      }
    },
    close () {
      this.list = 'crop'
      this.reset()
      this.$emit('close')
    },
    save () {
      fetch(this.imageKonva.src, {
        cache: 'no-cache',
      })
        .then(res => res.blob())
        .then(blob => {
          const file = new File([blob], this.item.name, blob)
          this.$emit('save', file)
        })
        .finally(() => {
          this.close()
        })
    },
    init () {
      this.loading = true
      this.image = null
      this.cropImg = null
      this.drawImg = null
      fetch(this.item.download_url, {
        cache: 'no-cache',
      })
        .then(res => res.blob())
        .then(blob => {
          const url = URL.createObjectURL(blob)
          this.image = url
        })
        .finally(() => {
          this.dialog = true
          this.loading = false
        })
    },
    createImage (download) {
      const img = document.getElementById('image_tune')
      const canvas = document.createElement('canvas')
      canvas.width = img.clientWidth
      canvas.height = img.clientHeight
      const ctx = canvas.getContext('2d')
      ctx.filter = this.filters.filter
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
      const link = document.createElement('a')
      link.href = canvas.toDataURL()
      if (download) {
        link.download = this.item.name
        link.click()
      } else {
        const image = new Image()
        image.src = link.href
        image.onload = () => {
          this.imageKonva = image;
          setTimeout(() => {
            // this.list = 'draw'
            this.save()
          }, 500)
        }
      }
    },
    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.imageToCrop =  this.$refs.cropper.getCroppedCanvas().toDataURL();
    },
    confirmCrop () {
      this.loading = true
      setTimeout(() => {
        const cropper = this.$refs.cropper
        const data = cropper.getImageData()
        const src = cropper.getCroppedCanvas({ width: data.naturalWidth, height: data.naturalHeight}).toDataURL()
        const image = new Image()
        image.src = src
        image.onload = () => {
          this.cropImg = image
          this.reset()
          this.list = 'draw'
          this.loading = false
        }
      }, 1000)
    },
    confirmDraw () {
      this.handleStageMouseDown(null, true)
      console.log(this.$refs.stage)
      const stage = this.$refs.stage.getStage();
      console.log("confirmDraw ~ stage", stage)
      this.drawImg = stage.toDataURL()
      this.list = 'tune'
    },
    // Shapes
    addRect() {
      this.index++
      const obj = {
        ...this.configRect
      }
      obj.name += this.index
      this.rectangles.push(obj)
    },
    removeRect() {
      const index = this.rectangles.findIndex((r) => r.name === this.selectedShapeName)
      this.rectangles.splice(index, 1)
      this.handleStageMouseDown(null, true)
    },
    handleTransformEnd(e) {
      // shape is transformed, let us save new attrs back to the node
      // find element in our state
      const rect = this.rectangles.find(
        (r) => r.name === this.selectedShapeName
      );
      // update the state
      rect.x = e.target.x();
      rect.y = e.target.y();
      rect.rotation = e.target.rotation();
      rect.scaleX = e.target.scaleX();
      rect.scaleY = e.target.scaleY();
    },
    handleStageMouseDown(e, clear) {
      // clicked on stage - clear selection
      if (clear || e.target === e.target.getStage()) {
        this.selectedShapeName = '';
        this.updateTransformer();
        return;
      }

      // clicked on transformer - do nothing
      const clickedOnTransformer = e.target.getParent().className === 'Transformer';
      if (clickedOnTransformer) {
        return;
      }

      // find clicked rect by its name
      const name = e.target.name();
      const rect = this.rectangles.find((r) => r.name === name);
      if (rect) {
        this.selectedShapeName = name;
      } else {
        this.selectedShapeName = '';
      }
      this.updateTransformer();
    },
    updateTransformer() {
      // here we need to manually attach or detach Transformer node
      const transformerNode = this.$refs.transformer.getNode();
      const stage = transformerNode.getStage();
      const { selectedShapeName } = this;

      const selectedNode = stage.findOne('.' + selectedShapeName);
      // do nothing if selected node is already attached
      if (selectedNode === transformerNode.node()) {
        return;
      }

      if (selectedNode) {
        // attach to another node
        transformerNode.nodes([selectedNode]);
      } else {
        // remove transformer
        transformerNode.nodes([]);
      }
      transformerNode.getLayer().batchDraw();
    },
  },
}
</script>
